import { render, staticRenderFns } from "./RListTitle.vue?vue&type=template&id=b5cf067c&scoped=true"
import script from "./RListTitle.vue?vue&type=script&lang=js"
export * from "./RListTitle.vue?vue&type=script&lang=js"
import style0 from "./RListTitle.vue?vue&type=style&index=0&id=b5cf067c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cf067c",
  null
  
)

export default component.exports